import { Injectable } from '@angular/core';
import { PageService } from './page.service';
import { ProyectoItem } from '../models/proyecto-item';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProyectosItemService extends PageService<ProyectoItem> {

  constructor(http: HttpClient) {
    super(http);
  }
}
